/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import GooglePlacesAutocomplete, {
  Place,
} from '../../../GooglePlacesAutocomplete';

import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';

type State = {
  inputValue: string;
};

type Props = {
  definition: FormFieldDefinition;
  value: Place | null | undefined;
  onChange: (id: string, value: Place | null | undefined) => void;
};

class LocationInputElementEditView extends Component<Props, State> {
  state: State = {
    inputValue: (this.props.value && this.props.value.textName) || '',
  };

  componentDidUpdate(prevProps: Props) {
    let newProps = this.props;
    let newText = newProps.value ? newProps.value.textName : '';
    let oldText = prevProps.value ? prevProps.value.textName : '';
    if (newText !== oldText) {
      this.setState({ inputValue: newText });
    }
  }

  componentDidMount() {
    let { value } = this.props;
    if (value) {
      this.setState({
        inputValue: value.textName,
      });
    }
  }

  render() {
    let { definition } = this.props;
    // TODO: Better solution here.
    if (definition.type !== 'LocationInput') {
      return null;
    }
    // let defaultValue = this.state.inputValue || '';
    return (
      <GooglePlacesAutocomplete
        placeholder={definition.placeholder ?? undefined}
        onPlaceSelect={this._onPlaceSelect}
        onBlur={this._onBlur}
        onChange={this._onChange}
        value={this.state.inputValue}
      />
    );
  }

  _onChange = (event: any) => {
    this.setState({ inputValue: event.target.value });
  };

  _onPlaceSelect = (place: Place) => {
    let { definition, onChange } = this.props;
    if (onChange != null) {
      onChange(definition.id, place);
    }
  };

  _onBlur = () => {
    let { inputValue } = this.state;
    let { value, definition, onChange } = this.props;
    if (!Object(definition).is_required && inputValue === '') {
      onChange(definition.id, null);
    } else if (value) {
      this.setState({
        inputValue: value.textName,
      });
    } else {
      this.setState({
        inputValue: '',
      });
    }
  };
}

export default LocationInputElementEditView;
